import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ConnectionRightHistory } from '@shared/interfaces/nts/connection-right';
import { TableComponent } from '@shared/components/table/table.component';
import { connectionRightHistoryTable } from '@shared/table-configs/connection-right/connection-right-history.table';

@Component({
  selector: 'app-connection-right-history',
  imports: [TableComponent],
  templateUrl: './connection-right-history.component.html',
})
export class ConnectionRightHistoryComponent implements OnChanges {
  @Input({ required: true }) public loadHistory!: () => Observable<ConnectionRightHistory[]>;
  @ViewChild(TableComponent) private table?: TableComponent<ConnectionRightHistory>;

  public readonly tableConfig = {
    ...connectionRightHistoryTable,
    fetchOnLoad: true,
    refreshable: true,
    serviceCallback: () => this.loadHistory().pipe(map(results => ({ results }))),
  };

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['loadHistory'] && !changes['loadHistory'].firstChange) {
      this.table?.search();
    }
  }
}
